"use strict"

import Axios from "../../../services/AxiosService"

class AdministrativeCorrectionsService extends Axios {
  async index() {
    return this.request({ method: "GET", url: "administrative-corrections" })
  }
}

export default () => new AdministrativeCorrectionsService()
